module.exports = __webpack_public_path__ + "static/media/PM-GATISHAKTI-TAG.9819edfe.svg";